// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { BoxField, SwitchButton, Text, View } from "@components";

import type { ManagerSelfServiceSettings } from "@modules/service/reducer/manager-self-service/types";

type Props = {
  settings: ManagerSelfServiceSettings,
  onUpdateSettings: (settings: ManagerSelfServiceSettings) => void,
  onAdd: () => void,
  ...PropsFromLocalize,
};

export function ManagerSelfService({ settings, t, onUpdateSettings }: Props) {
  const updateEnabled = (settingsName: string) => (value: boolean) => {
    onUpdateSettings({ ...settings, [settingsName]: value });
  };

  return (
    <View gap={4}>
      <View direction="row" justifyContent="space-between" alignItems="center">
        <Text type="h5">{t("MANAGER_SELF_SERVICE")}</Text>
      </View>

      <BoxField title={t("ADD_EDIT_ABSENCES")} description={t("ADD_EDIT_ABSENCES_DESCRIPTION")}>
        <SwitchButton
          active={settings.addAndEditAbsences}
          onChange={updateEnabled("addAndEditAbsences")}
        />
      </BoxField>

      <BoxField title={t("CANCEL_ABSENCES")} description={t("CANCEL_ABSENCES_DESCRIPTION")}>
        <SwitchButton active={settings.cancelAbsences} onChange={updateEnabled("cancelAbsences")} />
      </BoxField>

      <BoxField title={t("NOTIFICATION_ADMIN")} description={t("NOTIFICATION_ADMIN_DESCRIPTION")}>
        <SwitchButton
          active={settings.notificationContactsAdmin}
          onChange={updateEnabled("notificationContactsAdmin")}
        />
      </BoxField>
    </View>
  );
}

export default compose(localize())(ManagerSelfService);
